<template>
  <div class="eq-empty-state">
    <div class="eq-empty-state__icon">
      <i :class="icon"></i>
    </div>
    <div class="eq-empty-state__title">{{ title }}</div>
    <div v-if="description" class="eq-empty-state__desc">{{ description }}</div>
    <div v-if="$slots.default" class="eq-empty-state__action">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    title: { type: String, default: '暂无数据' },
    description: { type: String, default: '' },
    icon: { type: String, default: 'el-icon-document' }
  }
}
</script>

<style lang="scss" scoped>
.eq-empty-state { padding: 48px 24px; text-align: center; }
.eq-empty-state__icon {
  width: 64px; height: 64px; margin: 0 auto 16px; border-radius: 16px;
  display: flex; align-items: center; justify-content: center;
  background: var(--eq-gray-100); color: var(--eq-text-tertiary); font-size: 28px;
}
.eq-empty-state__title { font-size: 14px; font-weight: 500; color: var(--eq-text-secondary); }
.eq-empty-state__desc { margin-top: 8px; font-size: 13px; color: var(--eq-text-tertiary); }
.eq-empty-state__action { margin-top: 16px; }
</style>
